<template>
  <div>
    <div class="content d-flex flex-column mt-2" v-if="fields">
      <v-row>
        <v-col :cols="isClient ? 12 : 3">
          <input-v
            v-model="projeto.id_projeto"
            :valid.sync="fieldsComputed.id_projeto.valid"
            :label="fieldsComputed.id_projeto"
            :editable="canEdit"
          >
          </input-v>
        </v-col>
        <v-col :cols="isClient ? 12 : 9">
          <input-v
            v-model="projeto.titulo"
            :valid.sync="fieldsComputed.titulo.valid"
            :label="fieldsComputed.titulo"
            :editable="canEdit"
          ></input-v>
        </v-col>
      </v-row>
      <v-row class="mt-n2" v-if="!isAgrupamento">
        <v-col>
          <input-v
            v-model="projeto.titulo_transmissao"
            :valid.sync="fieldsComputed.titulo_transmissao.valid"
            :label="fieldsComputed.titulo_transmissao"
            :editable="canEdit"
          ></input-v>
        </v-col>
      </v-row>
      <v-row class="mt-n2">
        <v-col v-if="!isClient">
          <input-v 
            v-model="projeto.trabalho"
            :valid.sync="fieldsComputed.trabalho.valid"
            :label="fieldsComputed.trabalho"
            :editable="canEdit && cliente.trabalho == 3"
            :opts="opts"
          >
          </input-v>
        </v-col>
        <v-col>
          <input-v
            v-model="projeto.status"
            :label="fieldsComputed.status"
            :editable="canEditStatus"
            :opts="opts"
          >
          </input-v>
        </v-col>      
      </v-row>
      <div class="row align-items-center mt-n2">
        <div class="col">
          <input-v
            v-model="projeto.data_inicio"
            :valid.sync="fieldsComputed.data_inicio.valid"
            :label="fieldsComputed.data_inicio"
            :editable="canEdit"
          ></input-v>
        </div>
        <div  class="col">
          <input-v
            v-model="projeto.data_fim"
            :valid.sync="fieldsComputed.data_fim.valid"
            :label="fieldsComputed.data_fim"
            :editable="canEdit"
          ></input-v>
        </div>
        <div class="col">
          <input-v
            v-model="projeto.ano_base"
            :valid.sync="fieldsComputed.ano_base.valid"
            :label="fieldsComputed.ano_base"
            :editable="canEdit"
          ></input-v>
        </div>
        <div class="col-auto" :lg="isClient || !hasAccessPlurianual ? 3 : 3" sm="12" xs="12">
          <button 
            :style="`background-color: ${primaryColor}; color: white; padding: 0.8rem; border-radius: 5px`"
            @click="
              onPlurianualOpen();
              plurianualDialog = true;
            "
          >
            Gerar novo ano-base
          </button>
          <form-modal
            :cols="plurianualField"
            :maxWidth="plurianualDialogWidth"
            :opened.sync="plurianualDialog"
            :opts="opts"
            title="Gerar Outro Ano Base"
            :value.sync="plurianualData"
            @save="gerarProximoAnoBase($event)"
          ></form-modal>
        </div>
      </div>

      <div class="responsaveis">
        <div class="header row mt-5 p-2">
          <div class="header col">
            <h3 class="h3 bold">Responsáveis</h3>
          </div>
          <div class="action col-auto">
            <button v-if="projeto.responsaveis && projeto.responsaveis.length === 0" @click="handleCreateResponsavel" :style="`color: ${primaryColor}`" class="px-2">+ Adicionar responsável</button>
          </div>
        </div>
        <div class="content d-flex flex-column" v-if="projeto.responsaveis && projeto.responsaveis.length > 0">     
          <div v-for="(resp, index) in projeto.responsaveis" :key="index" class="mb-4 border border-black p-3 rounded">
            <div class="row  align-items-center">
              <div class="col">
                <div class="row">
                  <div class="col">
                    <label>Nome:</label>
                    <input v-model="resp.nome" type="text" placeholder="Nome" :class="`form-control mb-2 ${inputClass}`" />
                  </div>                            
                  <div class="col">
                    <label>CPF:</label>
                    <input :value="maskCPF(resp.cpf)" @input="updateCPF(resp, $event.target.value)" @blur="validateRespCPF(resp, index)" type="text" placeholder="CPF" :class="`form-control mb-2 ${inputClass}`" maxlength="14" />
                    <div class="invalid-feedback d-block" v-if="cpfInvalid[index]">CPF inválido.</div>
                  </div>
                </div>
                <div class="row">              
                  <div class="col">
                    <label>Email:</label>
                    <input v-model="resp.email" type="email" placeholder="Email" :class="`form-control mb-2 ${inputClass}`" />
                  </div>
                  <div class="col">
                    <label>Telefone:</label>
                    <input v-model="resp.telefone" type="text" placeholder="Telefone" :class="`form-control mb-2 ${inputClass}`" />
                  </div>
                </div>  
              </div>
              <div class="col-auto">
                <button @click="deleteResponsavel(index)" style="color: red; cursor:pointer">
                  <v-icon style="color: red; cursor:pointer">mdi-delete</v-icon>
                </button>
              </div>
            </div>
          </div>
        </div>
        <div v-else>
          <span class="form-text p-2">Nenhum responsável cadastrado.</span>
        </div>
      </div>
    </div>
    
  </div>
</template>

<script>
import { cloneDeep } from "lodash";
import fields from '../LIEnquadrados.fields';
import { projectsOptions } from "@/helpers/yearsOptions";
import { FieldTypeEnum } from "@/core/enums/field-types";
import moment from "moment";
import { mapGetters } from "vuex";
import { BeneficiosLabels } from "@/core/enums/beneficios";
import { UserTypeEnum } from "@/core/enums/user-types";
import { maskCPF, validateCPF } from "@/helpers/masks";
import { isStrictProject } from "@/helpers/projectValidators";

export default {
  props: {
    projeto: {
      type: Object,
      required: true
    },
    canEdit: {
      type: Boolean,
      required: true,
      default: false
    },
    canEditStatus: {
      type: Boolean,
      required: true,
      default: false
    },
    isClient: {
      type: Boolean,
      required: true,
      default: false
    },
    cliente: {
      type: Object,
      required: true
    },
    hasAccessPlurianual: {
      type: Boolean,
      required: true,
      default: false
    },
    opts: {
      type: Object,
      required: true,
      default: function() {
        return {};
      }
    },
    isAgrupamento: {
      type: Boolean,
      default: false
    }
  },
  components: {
    'input-v': () => import('@/components/input-v.vue'),
    'form-modal': () => import('@/components/form-modal.vue')
  },
  data() { 
    return {
      fields,
      plurianualDialog: false,
      plurianualData: {},
      projetosAgrupados: [],
      cpfInvalid: {},
    }
  },
  computed: {
    ...mapGetters(["clientId"]),
    plurianualField: function () {
      return [
        {
          key: "ano_base",
          name: "Gerar para o ano:",
          type: FieldTypeEnum.SELECT,
          rules: [{ rule: "required" }],
          rel: { toEdit: projectsOptions, id: "value", name: "text" },
          show: true,
          colSize: this.isAgrupamento ? 4 : 12,
        },
        {
          key: "projetos_agrupados",
          name: "Projetos desse agrupamento que serão replicadas junto do agrupamento",
          placeholder:
            "Nenhum projeto selecionado, agrupamento sera replicado vazio",
          type: FieldTypeEnum.AUTOCOMPLETE_MULTIPLE,
          rel: { to: this.projetosAgrupados, key: "id", name: "titulo" },
          show: this.isAgrupamento,
          colSize: 12,
        },
      ].filter(({ show }) => show);
    },
    plurianualDialogWidth: function () {
      return this.isAgrupamento ? "60%" : "20%";
    },
    fieldsComputed: function() {
      const fields = cloneDeep(this.fields.escopo);
      const isStrict = isStrictProject(this.projeto);

      return fields.reduce(
        (acc, field) => {
          if (!isStrict) {
             field.rules = (field.rules || []).filter(r => r.rule !== 'required');
          }
          return { ...acc, [field.key]: field }
        },
        {}
      );
    },
    primaryColor() {
       const user = this.$store.getters.user || {};
       const { tipo_usuario } = user;
       const isClient = [UserTypeEnum.GERENCIAL_CLIENTE, UserTypeEnum.COLABORADOR].includes(tipo_usuario);
       return isClient ? 'rgba(11, 84, 86, 0.9)' : '#1c1c44';
    },
    inputClass() {
      const user = this.$store.getters.user || {};
      const { tipo_usuario } = user;
      const isClient = [UserTypeEnum.GERENCIAL_CLIENTE, UserTypeEnum.COLABORADOR].includes(tipo_usuario);
      return isClient ? 'custom-input-client' : 'custom-input';
    }
  },
  methods: {
    maskCPF,
    updateCPF(resp, value) {
      // Remove caracteres não numéricos para salvar limpo
      const cleanValue = value.replace(/\D/g, '').slice(0, 11);
      this.$set(resp, 'cpf', cleanValue);
      // Força a renderização do valor mascarado no input se necessário (em casos onde o masked não muda mas o clean sim, ou vice versa, embora o :value deva cuidar disso)
      this.$forceUpdate();
    },
    validateRespCPF(resp, index) {
      if (!resp.cpf) {
         this.$set(this.cpfInvalid, index, false);
         return;
      }
      
      const isValid = validateCPF(resp.cpf);
      this.$set(this.cpfInvalid, index, !isValid);
    },
    handleCreateResponsavel() {
      if (!this.projeto.responsaveis) {
        this.$set(this.projeto, 'responsaveis', []);
      }
      this.projeto.responsaveis.push({
        nome: '',
        cpf: '',
        email: '',
        telefone: '',
        trabalho: this.projeto.trabalho,
        projeto_id: this.projeto.id
      });    
    },
    deleteResponsavel(index) {
      this.projeto.responsaveis.splice(index, 1);
    },
    onPlurianualOpen: function () {
      this.plurianualData = {
        projetos_agrupados: this.isAgrupamento
          ? this.projeto.projetos_agrupados.map(({ id }) => id)
          : undefined,
      };
      if (this.isAgrupamento) {
         this.projetosAgrupados = this.formatProjetosOptions(
            this.projeto.projetos_agrupados
          );
      }
    },
    gerarProximoAnoBase: function ({ ano_base, projetos_agrupados }) {
      const dataFimProjeto = this.projeto.data_fim;
      const dataAnoBase = moment(dataFimProjeto).get("year");
      if (dataFimProjeto && dataAnoBase < ano_base) {
        const dataFimExibicao = moment(dataFimProjeto).format("DD/MM/YYYY");
        this.showConfirm(
          `Projeto encerrado em ${dataFimExibicao}`,
          `Deseja prosseguir com a replicação do projeto para o ano ${ano_base}? O novo projeto será criado com data fim indefinida.`,
          () => {
            this.gerarAnoBase(ano_base, projetos_agrupados);
          }
        );
      } else {
        this.gerarAnoBase(ano_base, projetos_agrupados);
      }
    },
    gerarAnoBase: function (ano_base, projetos_agrupados) {
      this.apiResource(
        `v1/projetos/${this.clientId}/plurianual/${this.projeto.id}`
      )
        .save({ ano_base, projetos_agrupados })
        .then((response) => {
          if (response.error) {
            return;
          }

          this.plurianualDialog = false;
          const route = this.$router.resolve({
            name: "ficha-projeto-enquadrado",
            params: { projetoId: response.id },
          });
          window.open(route.href, "_blank");
        });
    },
    formatProjetosOptions: function (projetos) {
      if (!Array.isArray(projetos)) {
        return [];
      }

      return projetos
        .map((projeto) => {
          const trabalho =
            BeneficiosLabels[projeto.trabalho] || "Sem Benefício";
          const titulo = `${
            projeto.titulo || "Título não encontrado"
          } [${trabalho}]`;
          const disabled = this.projeto.trabalho != projeto.trabalho;
          return { ...projeto, disabled, titulo };
        })
        .sort((a, b) => {
          const { titulo: tituloA, trabalho: trabalhoA } = a;
          const { titulo: tituloB, trabalho: trabalhoB } = b;
          const disabledA = a.disabled ? 1 : 0;
          const disabledB = b.disabled ? 1 : 0;
          return (
            disabledA - disabledB ||
            trabalhoA - trabalhoB ||
            tituloA.localeCompare(tituloB)
          );
        });
    },
  },
  watch: {},
  created() {},
  mounted() {},
  beforeDestroy() {}
}
</script>

<style scoped>
.custom-input:focus {
  border-color: #1C1C44; 
  box-shadow: 0 0 0 0.2rem rgba(40, 42, 167, 0.25);
  outline: none
}
.custom-input {
  border-color: #ced4da;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.custom-input-client:focus {
  border-color: rgba(11, 84, 86, 0.9);
  box-shadow: 0 0 0 0.2rem rgba(11, 84, 86, 0.25);
  outline: none
}
.custom-input-client {
  border-color: #ced4da;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}
</style>